import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PLAN_CONFIG, PlanConfig } from '@lyceo/shared/plan/util-provider';
import { format } from 'date-fns';
import { LessonDto } from './+state/lesson/lesson.dto';

@Injectable({
  providedIn: 'root',
})
export class LessonService {
  private readonly planConfig: PlanConfig = inject<PlanConfig>(PLAN_CONFIG);
  private readonly http: HttpClient = inject(HttpClient);

  public getLessonsByDate(
    homiPersonId: string,
    date: Date,
  ): Observable<LessonDto[]> {
    const formattedDate: string = format(date, 'yyyy-MM-dd');
    const url: string = `${this.planConfig.homiApiUrl}/api/pupils/${homiPersonId}/lessons/${formattedDate}`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<LessonDto[]>(url, {
      headers: headersToSend,
    });
  }
}
